import React, { FC } from 'react';
import { Props } from './types';
import { Container, ContentLoader } from './styles';

// TODO: TFR-49 split components into two or more different logical components
export const TitleLoader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 1120 48" $opacity={opacity}>
        <rect width="111" height="26" rx="16" y="16" />
      </ContentLoader>
    </Container>
  );
};

export const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader viewBox="0 0 1120 48" $opacity={opacity}>
        <rect y="16" width="137" height="16" rx="8" />
        <rect x="288" y="16" width="91" height="16" rx="8" />
        <rect x="528" y="16" width="96" height="16" rx="8" />
        <rect x="783" y="16" width="48" height="16" rx="8" />
        <rect x="992" width="128" height="48" rx="24" />
      </ContentLoader>
    </Container>
  );
};
